"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverArrow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseStyle = require("../shared/baseStyle");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PopoverArrow = _styledComponents.default.div.withConfig({
  displayName: "PopoverArrow",
  componentId: "sc-37uo7c-0"
})(["", " width:", "px;height:", "px;&:after{", " content:'';position:absolute;top:-", ";left:-", "px;border-left:", "px solid transparent;border-right:", "px solid transparent;border-bottom:", "px solid ", ";", "}*[data-popper-placement^='top'] &{bottom:-", "px;&:after{transform:rotate(180deg);}}*[data-popper-placement^='bottom'] &{top:-", "px;}*[data-popper-placement^='left'] &{right:-", "px;&:after{transform:rotate(90deg) scaleX(0.75);}}*[data-popper-placement^='right'] &{left:-", "px;&:after{transform:rotate(-90deg) scaleX(0.75);}}"], _baseStyle.baseStyle, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, _baseStyle.baseStyle, function (props) {
  return props.size;
}, function (props) {
  return props.size * 0.5;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.color;
}, function (props) {
  return props.customCss;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

exports.PopoverArrow = PopoverArrow;